<div class="seneca-list-container">

  <mat-card class="main-container mat-elevation-z2">

    <div class="content-padding">
      <mat-card-content>
        <h1> Seneca Commission Policy</h1>

        <br />
        <br />

        <p class="policy-header">Schedule "B" Commission Policy</p>

        <br />

        <p>
          This policy for commission (this "<strong>Commission Policy</strong>") is effective as of April 1, 2020 and stays in effect until further notice from Seneca. The policy 
          applies to students who begin their studies at Seneca from May 2020 onward. 
        </p>
    
        <p>
          An Agency who holds a valid agency agreement (an "<strong>Agreement</strong>") with Seneca is entitled to be paid (i) a Commission for students recruited outside of 
          Canada or, (ii) an On-Shore Commission for On-Shore students placed with Seneca during the term of their Agreement. Capitalized terms not defined in 
          this Commission Policy shall have the meaning set out in the Agreement.
        </p>
    
        <h2>(A) Professional Programs</h2>

        <p>
          For International Students recruited outside of Canada, a Commission calculated with reference to an assigned percentage of the tuition fees paid by the students will be 
          paid for students enrolled in Seneca programs from countries noted in the Schedule "A" to the Agreement. Commissions are payable on a student's first two semesters of 
          paid tuition within a 12 month period.
        </p>

        <p>
          For On-Shore Students recruited by the Agency, an On-Shore Commission calculated with reference to an assigned percentage of the tuition fees paid by the students will be 
          paid for students enrolled in Seneca programs from countries noted in the Schedule "A" to the Agreement. Commissions are payable on a student's first two semesters of paid 
          tuition within a 12 month period.
        </p>

        <p>
          The assigned percentage of Commissions are disclosed in Schedule "A" to the Agreement. 
        </p>

        <p>
          Commission payments are paid in Canadian dollars by direct deposit or bank wire to the registered Agency ID/Agent ID number noted on the student's INITIAL online application 
          to Seneca.
        </p>

        <h2>(B) English Language Institute (ELI) Programs</h2>

        <p>
          A Commission of an assigned Canadian Dollar amount will be paid to registered Agency for each ELI level student registered by the Agency within a 12 month period, from countries 
          noted in Schedule "A" to the Agreement. The assigned Canadian Dollar amount is disclosed in the Schedule "A" to the Agreement. 
        </p>

        <p>
          Commission payments are paid in Canadian dollars by direct deposit or bank wire to the registered Agency ID/Agent ID number noted on the student's INITIAL online application to 
          Seneca. 
        </p>

        <p>
          Commissions in respect of Section A and B above will be claimed and submitted by the Agency to Seneca for review after the 25th day of study and during the commission window 
          published on Seneca's website <a href="https://www.senecacollege.ca/international/agency-information/registered-seneca-agent.html">https://www.senecacollege.ca/international/agency-information/registered-seneca-agent.html</a>.
        </p>

        <p>
          All commission claims should be submitted via the Registered Agent Portal at 
          <a href="https://apps.senecacollege.ca/studyatseneca/jsp/AgentSignIn.jsp">https://apps.senecacollege.ca/studyatseneca/jsp/AgentSignIn.jsp</a>.
        </p>

        <h2>(C) Monitoring Agency Commissions</h2>

        <p>
          The Agency can monitor their claims though Seneca's Agency Portal where the status of Outstanding Payments for each specific student placed during the term will be available.
        </p>

        <h2>(D) Eligibility For Commission</h2>

        <ol type="i">
          <li>
            There must be a valid Agreement between the Agency and Seneca.
          </li>

          <li>
            The enrolled student must hold citizenship from an approved Jurisdiction of recruitment outlined in the Agreement.
          </li>
                  
          <li>
            The Agency must have placed the student(s) to study at Seneca during the Term and the Agent's ID or Agency ID must have beens noted on the student's initial application to Seneca.
          </li>
                  
          <li>
            The student must be registered as a Full-Time Student. Alternatively, the student must be registered in the English (ELI) program for the Agency to be eligible for Commission.
          </li>
                  
          <li>
            The student placed by the Agency must remain enrolled in the Seneca Professional or ELI program beyond the 10th day of study at the beginning of each semester.
          </li>
                  
          <li>
            Student tuition, ancillary, and health insurance fees must have been paid in accordance with Seneca's procedures that are in effect for the semester that the student enrolled in and the 
            student must have a full-time timetable. Outstanding tuition fees owed by a student after the 10th day of study are ineligible for commissions and cannot be requested at a later date 
            when fees are paid.
          </li>
        </ol>

        <h2>(E) Non-Payment of Commission</h2>

        <p>Seneca Agency Review Committee shall decide not to pay a Commission to an Agency if:</p>

        <ol type="i">

          <li>
            The student's initial application to Seneca does not indicate the Agency's Agent ID or Agency ID.
          </li>

          <li>
            The student was recruited from a non-approved Jurisdiction.
          </li>

          <li>
            The Services were not performed by the Agency.
          </li>

          <li>
            The Agency’s Agreement has expired and/or a renewed Agreement has not been signed between Seneca and the Agency.
          </li>

          <li>
            A student in their professional program or ELI program drops the program prior to the 10th day of study at the beginning of each semester.
          </li>

          <li>
            The student is a returning Seneca student beyond their first 12 months of study.
          </li>

          <li>
            Any other reason where payment to the Agency would be improper or fraudulent.
          </li>

        </ol>

      </mat-card-content>
    </div>

  </mat-card>

</div>